// extracted by mini-css-extract-plugin
module.exports = {"container":"capacitor_container__12Kb3","button":"capacitor_button__3YkUX"};